import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TenantService } from 'src/app/shared/services/tenant/tenant.service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';

@Component({
  selector: 'app-tenant-job-modal',
  templateUrl: './tenant-job-modal.component.html',
  styleUrls: ['./tenant-job-modal.component.scss']
})
export class TenantJobModalComponent implements OnInit {
  @Input() tenantName: string;  

  private modalRef: NgbModalRef;
  isRunning: boolean = false;

  constructor(private tenantService: TenantService, private router: Router, private modalService: NgbModal, private activeModal: NgbActiveModal,
    private toastr: ToastService) { }

  ngOnInit(): void {
  }

  onRunJobButtonClick(){
    this.isRunning = true;
    this.tenantService.jobRun(this.tenantName).subscribe((message: any) => {  
      if (message == "Success" || message == "ContinueJob"){
        this.toastr.showSuccess("Refresh page for job status update.", "Job triggered.");
      }
      else if(message == "FileNotExist"){
        this.toastr.showError("No survey is available in " + this.tenantName + " folder", message);
      }
      else if (message == "JobRunning" ){
        this.toastr.showError("ETL Job is currently running", message);     
      }
      else { this.toastr.showError("Job service failed!", message); }
      
      this.router.navigate(['/details/'+ this.tenantName]);
      this.activeModal.close(true);
     });
  }

  onCloseModal() {
    let url = `/details/${this.tenantName}`;
    this.router.navigate([url]);
    this.activeModal.close(true);
  }

}
